import { RootState } from "@src/store";
import { OrderEntity, OrderMissionEntity } from '@src/features/order/entities';

export const selectSelectedHistoryOrder = (state: RootState) =>
  (state as { history: { selectedOrder: OrderEntity | OrderMissionEntity | null } }).history
    .selectedOrder;
